import { z } from 'zod';

export const WorkflowSchema = z.object({
  businessAreaId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  processId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  tasks: z.any().optional(),
  workflowName: z
    .string()
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  description: z
    .string()
    .max(255, {
      message: `error.field_max_lengh_255`,
    })
    .optional(),
});

export type FormWorkflowSchemaType = z.infer<typeof WorkflowSchema>;

export interface WorkflowSchemaType extends FormWorkflowSchemaType {
  id?: number;
}
